<template>
  <div class="multiple-upload">
    <v-dialog v-model="value" persistent max-width="800">
      <v-card>
        <v-card-title class="ma-0">
          <v-spacer />
          <v-btn icon small :loading="loading" @click="handleCancel"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex v-for="(image, index) in images" :key="`image_${index}`" xs4 md3 lg2 d-flex>
              <v-card flat class="d-flex">
                <v-card-text>
                  <div style="border-radius: 10px; border: 1px solid #eeee; position: relative">
                    <v-img :src="image.url" aspect-ratio="1" class="grey lighten-2">
                      <template #placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-layout>
                      </template>
                    </v-img>

                    <div
                      style="position: absolute; right: 0px; top: 0px"
                      @click="handleDeleteImage(index)"
                    >
                      <v-btn icon><v-icon>delete</v-icon></v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <template v-if="images.length < maxLength && !loading">
            <div
              class="text-xs-center imageBtn"
              :class="{ dropover: isDropover }"
              @click="onAddImage"
              @dragover="onDragover"
              @dragleave="onDragleave"
              @drop="onDrop"
            >
              <v-layout justify-center align-center row style="height: 100%" class="py-4 px-2">
                <div class="text-xs-center">Click to upload or drag image to here</div>
              </v-layout>
            </div>
          </template>
          <div
            v-if="images.length > 5"
            class="mt-3"
            :style="{
              color: 'red'
            }"
          >
            *กรณีตอบกลับภายใน 20 นาที หากแอดมินหรือแชทบอทยังไม่ได้ทำการตอบกลับลูกค้า
            การส่งรูปภาพและVDO มากกว่า 5 ไฟล์ต่อ 1 ครั้งในครั้งแรก จะไม่เสียค่าข้อความ (Push
            message) และทุกๆ 5 ไฟล์ถัดไปถูกคิดค่าข้อความเป็น 1 (Push message)
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" outline :loading="loading" @click="handleCancel">{{
            $t('cancel')
          }}</v-btn>
          <v-btn color="primary" depressed :loading="loading" @click="handleSend">
            {{ $t('Send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <input
      id="photoUploadInput"
      type="file"
      accept="image/*"
      multiple
      style="
        height: 0px;
        width: 0px;
        visibility: hidden;
        position: fixed;
        margin-left: -999px;
        left: 0;
      "
      @input="onFileChange($event)"
    />
  </div>
</template>

<script>
import api from '@/api'
const events = ['dragenter', 'dragover', 'dragleave', 'drop']

import FileUpload from 'vue-upload-component'
export default {
  components: {
    FileUpload
  },
  props: { value: {}, maxLength: { default: 100 } },
  data() {
    return {
      images: [],
      singleImage: null,
      isDropover: false,
      loading: false
    }
  },
  computed: {},
  mounted() {
    events.forEach((eventName) => {
      document.body.addEventListener(eventName, this.preventDefaults)
    })
  },
  beforeDestroy() {
    events.forEach((eventName) => {
      document.body.removeEventListener(eventName, this.preventDefaults)
    })
  },
  methods: {
    onAddImage() {
      document.getElementById('photoUploadInput').click()
    },
    onFileChange(event) {
      const files = event.target.files || event.dataTransfer.files
      this.addImageIntoArray([...files])
      event.target.value = ''
    },
    fileResize: function (file) {
      let vm = this
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onloadend = function () {
          var tempImg = new Image()
          tempImg.src = reader.result
          tempImg.onload = function () {
            var MAX_WIDTH = 2000
            var MAX_HEIGHT = 2000
            if (vm.outputtype == 'base64') {
              MAX_WIDTH = 500
              MAX_HEIGHT = 500
            }
            var tempW = tempImg.width
            var tempH = tempImg.height

            if (tempW > tempH) {
              if (tempW > MAX_WIDTH) {
                tempH *= MAX_WIDTH / tempW
                tempW = MAX_WIDTH
              }
            } else {
              if (tempH > MAX_HEIGHT) {
                tempW *= MAX_HEIGHT / tempH
                tempH = MAX_HEIGHT
              }
            }

            if (tempW != 1040) {
              tempW = parseInt(tempW)
              tempH = parseInt(tempH)
              if (tempW > tempH) {
                let radio = tempH / tempW
                tempW = 1040
                tempH = tempW * radio
              } else {
                let radio = tempH / tempW
                tempW = 1040
                tempH = tempW * radio
              }
            }
            if (vm.outputtype == 'base64') {
              MAX_WIDTH = 500
              MAX_HEIGHT = 500
            }
            vm.tempWidth = tempW
            vm.tempHeight = tempH
            var canvas = document.createElement('canvas')
            canvas.width = tempW
            canvas.height = tempH

            var ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0, tempW, tempH)
            var dataURL = null
            if (file.type == 'image/png') {
              dataURL = canvas.toDataURL('image/png')
            } else {
              dataURL = canvas.toDataURL('image/jpeg')
            }
            var data = 'image=' + dataURL
            try {
              if (vm.outputtype == 'base64') {
                // vm.$emit('input', dataURL)
                vm.currentImage = dataURL
                vm.$emit('onUploaded', dataURL)
              }
              var obj = vm.dataURItoBlob(data)
              obj.name = file.name

              resolve(obj)
            } catch (error) {
              vm.$swal({
                title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
                type: 'error',
                text: `dataURItoBlob: ${error}`,
                confirmButtonText: vm.$t('Confirm')
              })
              reject()
            }
          }
        }
        reader.readAsDataURL(file)
      })
    },
    async handleSend() {
      const vm = this
      if (vm.images.length === 0) {
        await vm.$swal.fire({
          title: 'Upload at least one image',
          type: 'error'
        })
      } else {
        vm.loading = true
        const files = vm.images
        const resizeFiles = await Promise.all(
          files.map(async (obj) => {
            return {
              ...obj,
              file: await vm.fileResize(obj.file)
            }
          })
        )

        vm.loading = false
        vm.images = []
        vm.$emit('input', false)

        const s3url = await Promise.all(
          resizeFiles.map(async (obj) => {
            return { ...obj, s3Url: await vm.createImage(obj.file) }
          })
        )

        const messages = s3url.map((obj) => {
          return { image_url: obj.s3Url, type: 'image' }
        })

        vm.$emit('handleSendImages', {
          messages: messages,
          onComplete: function () {
            vm.$emit('input', false)
          }
        })
      }
    },

    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    handleCancel() {
      this.images = []
      this.$emit('input', false)
    },
    uploadImages() {},
    onDragover(e) {
      e.preventDefault()
      this.isDropover = true
    },
    onDragleave(e) {
      this.isDropover = false
    },
    onDrop(e) {
      e.preventDefault()
      const files = [...e.dataTransfer.files]
      this.addImageIntoArray(files)
    },
    addImageIntoArray(files) {
      const images = files.filter((file) => {
        const type = file.type.toLowerCase()
        return type == 'image/png' || type == 'image/jpeg' || type == 'image/jpg'
      })

      if (images) {
        const imageWithUrl = images.map((image) => {
          return {
            file: image,
            url: URL.createObjectURL(image)
          }
        })
        const spliceImages = [...this.images, ...imageWithUrl]
        this.images = spliceImages.slice(0, this.maxLength)
      }
    },
    handleDeleteImage(index) {
      this.images.splice(index, 1)
    },
    async createImage(file) {
      try {
        return await this.upload(file)
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `upload: ${error}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file
      }
      let vm = this
      return new Promise((resolve, reject) => {
        api.getSignedRequest(data, function (error, url) {
          if (error) {
            reject(error)
          }

          url = encodeURI(url)

          vm.currentImage = url
          // vm.$emit('input', vm.currentImage, { width: vm.tempWidth, height: vm.tempHeight })
          if (vm.multiple) {
            vm.multiplefile.push(vm.currentImage)
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
            }
          } else {
            vm.$emit('onUploaded', vm.currentImage)
          }
          resolve(vm.currentImage)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.imageBtn {
  height: 80px;
  border: 3px dashed #eee;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    background: #eee;
  }
  &.dropover {
    background: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/UploadMultipleImage/UploadMultipleImage.vue